import React from 'react';
import { careerJourney } from '../data/corporateData';
import { Building2, Circle } from 'lucide-react';

const CorporateCareerTimeline = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0F172A]" id="career">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        {/* Section Header */}
        <div className="mb-12 max-w-3xl">
          <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading mb-4 block">
            Professional Journey
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-4 font-heading">
            Career Trajectory & Leadership Evolution
          </h2>
          <p className="text-base text-slate-300 leading-relaxed font-body">
            Two decades of progressive leadership across India's premier entertainment organizations
          </p>
        </div>

        {/* Timeline */}
        <div className="relative" data-testid="career-timeline">
          {/* Vertical Line */}
          <div className="absolute left-0 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-rose-500/50 via-rose-500/30 to-rose-500/10 hidden sm:block"></div>

          {/* Timeline Items */}
          <div className="space-y-12">
            {careerJourney.map((item) => {
              const itemIndex = careerJourney.indexOf(item);
              return (
              <div
                key={item.id}
                className={`relative flex flex-col md:flex-row gap-8 items-start ${
                  itemIndex % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
                data-testid={`timeline-item-${item.id}`}
              >
                {/* Timeline Dot */}
                <div className="hidden md:flex absolute left-1/2 top-8 -translate-x-1/2 w-4 h-4 bg-rose-500 rounded-full border-4 border-[#0F172A] z-10">
                  {item.current && (
                    <span className="absolute inset-0 rounded-full bg-rose-500 animate-ping opacity-75"></span>
                  )}
                </div>

                {/* Content Card */}
                <div className={`flex-1 ${itemIndex % 2 === 0 ? 'md:text-right md:pr-12' : 'md:pl-12'}`}>
                  <div className="bg-[#112240] border border-white/10 rounded-lg p-6 hover:border-rose-500/50 transition-all duration-300">
                    {/* Year Badge */}
                    <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-500/10 border border-rose-500/30 mb-4 ${itemIndex % 2 === 0 ? 'md:float-right md:ml-4' : 'md:float-left md:mr-4'}`}>
                      <Circle className="text-rose-500" size={8} fill="currentColor" />
                      <span className="text-xs font-bold text-rose-500 font-heading">
                        {item.year}
                      </span>
                      {item.current && (
                        <span className="text-xs font-bold text-white bg-rose-500 px-2 py-0.5 rounded">
                          Current
                        </span>
                      )}
                    </div>

                    {/* Company */}
                    <div className="flex items-center gap-2 mb-2">
                      <Building2 className="text-slate-400" size={18} />
                      <h3 className="text-xl font-semibold text-white font-heading">
                        {item.company}
                      </h3>
                    </div>

                    {/* Role */}
                    <p className="text-lg font-medium text-rose-400 mb-3 font-body">
                      {item.role}
                    </p>

                    {/* Description */}
                    <p className="text-sm text-slate-300 leading-relaxed font-body clear-both">
                      {item.description}
                    </p>

                    {/* Image if available */}
                    {item.image && (
                      <div className="mt-4 rounded-lg overflow-hidden">
                        <img
                          src={item.image}
                          alt={`${item.company} - ${item.year}`}
                          className="w-full h-48 object-cover"
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="flex-1 hidden md:block"></div>
              </div>
            );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CorporateCareerTimeline;
